import { MenuNodeType } from "components/Menu/model";

import { SubMenuNode, SubMenuNodeBaseProps } from "../SubMenuNode/SubMenuNode";

export interface SubMenuChildNodesProps extends SubMenuNodeBaseProps {
  childNodes?: MenuNodeType.Any[];
}

const skipFocusIdxWhenSectionLabel = ({
  focus,
  focusIdx,
  index,
  nodeType,
}: {
  focusIdx: number;
  index: number;
  focus: boolean;
  nodeType?: string;
}) => {
  if (focusIdx === index && focus && nodeType === "sectionLabel") {
    return focusIdx + 1;
  }

  return focusIdx;
};

export const SubMenuChildNodes = ({
  childNodes,
  isMobile,
  expansionLinkText,
  focus,
  containerLinkText,
}: SubMenuChildNodesProps) => {
  let focusIdx = 0;
  return (
    // To satisfy type error for SubMenuChildNodes not returning as JSX.Element
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {childNodes?.map((childNode, index) => {
        if (childNode.mobileOnly && !isMobile) {
          focusIdx++;
          return null;
        }

        focusIdx = skipFocusIdxWhenSectionLabel({
          focusIdx,
          index,
          focus,
          nodeType: childNode.nodeType,
        });

        return (
          <SubMenuNode
            key={`${childNode.titleKey}-${index}`}
            childNode={childNode}
            isMobile={isMobile}
            focus={focus && focusIdx === index}
            expansionLinkText={expansionLinkText}
            containerLinkText={containerLinkText}
          />
        );
      })}
    </>
  );
};
